import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { block } from "../../../core/react";

var omit = require("lodash/omit");
/*
 * Input validates input and only calls onChange for valid values
 */


export var NumberInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput(props) {
    var _this;

    _classCallCheck(this, NumberInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberInput).call(this, props));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(NumberInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "isValid",
    value: function isValid(value) {
      value = '' + value; // ensure string
      // Weird number check, please do something else

      return '' + parseInt(value, 10) == value;
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var _this$props = this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;
      var value = e.target.value;
      this.setState({
        value: value
      });

      if (this.isValid(value) && onChange) {
        onChange(value, field);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var rest = omit(this.props, ['field', 'onChange']);
      return React.createElement("input", Object.assign({
        type: "number"
      }, rest, {
        value: this.state.value,
        onChange: this.onChange
      }));
    }
  }]);

  return NumberInput;
}(React.Component);
NumberInput.defaultProps = {
  value: ''
};
export var RangeInput =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(RangeInput, _React$Component2);

  function RangeInput(props) {
    var _this2;

    _classCallCheck(this, RangeInput);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RangeInput).call(this, props)); // this.handleInputChange = this.handleInputChange.bind(this);

    _this2.handleSubmit = _this2.handleSubmit.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(RangeInput, [{
    key: "handleInputChange",
    value: function handleInputChange(_value, _key) {// const { min, max, minValue, maxValue, onFinished } = this.props
      // const values = defaults({
      //   [key]: clamp(value, min, max)
      // }, {
      //   min: minValue, max: maxValue
      // })
      // onFinished(values)
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.onFinished({
        min: this.refs.min.state.value,
        max: this.refs.max.state.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          mod = _this$props2.mod,
          className = _this$props2.className,
          minValue = _this$props2.minValue,
          maxValue = _this$props2.maxValue,
          translate = _this$props2.translate,
          minPlaceholder = _this$props2.minPlaceholder,
          maxPlaceholder = _this$props2.maxPlaceholder;
      var bemBlocks = {
        container: block(mod).el
      };
      return React.createElement("form", {
        className: bemBlocks.container().mix(className),
        onSubmit: this.handleSubmit
      }, React.createElement(NumberInput, {
        ref: "min",
        className: bemBlocks.container("input"),
        value: minValue,
        field: "min",
        onChange: this.handleInputChange,
        placeholder: translate('range.min') || minPlaceholder
      }), React.createElement("div", {
        className: bemBlocks.container("to-label")
      }, translate('range.to') || '-'), React.createElement(NumberInput, {
        ref: "max",
        className: bemBlocks.container("input"),
        value: maxValue,
        field: "max",
        onChange: this.handleInputChange,
        placeholder: translate('range.max') || maxPlaceholder
      }), React.createElement("button", {
        type: "submit",
        className: bemBlocks.container("submit")
      }, translate('range.submit') || 'Go'));
    }
  }]);

  return RangeInput;
}(React.Component);
RangeInput.defaultProps = {
  mod: "sk-range-input",
  translate: function translate(_str) {
    return undefined;
  },
  minPlaceholder: 'min',
  maxPlaceholder: 'max'
};